export const shadow_well =`
.shadow-well {
    box-shadow: 0 2px 2px 0 rgba(34, 34, 34, 0.08);
  }
`;
export const shadow_tile =`
  .shadow-tile {
    box-shadow: 0px 2px 2px rgba(34, 34, 34, 0.15), 0px -2px 4px rgba(34, 34, 34, 0.02);
  }
`;
export const shadow_popover =`
  .shadow-popover {
    box-shadow: 0px 4px 8px rgba(34, 34, 34, 0.15), 0px 0px 6px rgba(34, 34, 34, 0.02);
  }
`;
export const shadow_product =`
  .shadow-product {
    box-shadow: 0px 8px 16px rgba(34, 34, 34, 0.2), 0px 0px 8px rgba(34, 34, 34, 0.02);
  }
`;
export const shadow_dropdown =`
  .shadow-dropdown {
    box-shadow: 0px 8px 16px rgba(34, 34, 34, 0.3), 0px 0px 8px rgba(34, 34, 34, 0.0224185);
    border-radius: 2px;
  }
`;
export const shadow_card =`
  .shadow-card {
    box-shadow: 0px 10px 20px rgba(34, 34, 34, 0.35), 0px 0px 9px rgba(34, 34, 34, 0.0224185);
    border-radius: 4px;
  }
`;
export const shadow_modal =`
  .shadow-modal {
    box-shadow: 0px 12px 24px rgba(34, 34, 34, 0.4), 0px 0px 10px rgba(34, 34, 34, 0.02);
  }
`;